import { Button } from "@mui/material";
import { ComponentProps, PropsWithChildren, MouseEventHandler } from "react";
import { Link, HistoryState } from "@tanstack/react-router";

type Props = PropsWithChildren<{ to: string; state?: Partial<HistoryState> }> &
  Pick<ComponentProps<typeof Button>, "variant" | "color" | "size" | "disabled" | "sx"> & {
    onClick?: MouseEventHandler<HTMLAnchorElement>;
    target?: "_blank";
  };

const RouterLinkButton = ({ children, variant = "contained", onClick, ...rest }: Props) => {
  return (
    <Button component={Link} variant={variant} {...rest} onClick={onClick}>
      {children}
    </Button>
  );
};

export default RouterLinkButton;
